module.exports = __webpack_public_path__ + "img/equip-pic2.5a6bc99d.png";